import React, { useState, useRef, useEffect } from "react";
import Box from "@mui/material/Box";
import Input from "@mui/material/Input";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";

import SettingTextField from "./SettingTextField";

import { ReactComponent as InfoIcon } from "../assets/images/rest_info.svg";

const PortalSettingsColorInput = (props) => {
  const { label, value, error = "", info = "" } = props;
  const [colorVal, setColorVal] = useState(value);
  const timerRef = useRef();

  useEffect(() => {
    setColorVal(value);
  }, [value]);

  const handleInputChange = (val) => {
    setColorVal(val.toUpperCase());
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      props.handleInputChange(val.toUpperCase());
    }, 250);
  };

  return (
    <>
      <Box mb={1} display={"flex"} alignItems={"center"}>
        <Typography
          sx={{
            color: "#000000",
            fontSize: 14.5,
            fontFamily: "GilroySemiBold !important",
          }}
        >
          {label}
        </Typography>
        {info ? (
          <Tooltip
            componentsProps={{
              tooltip: {
                sx: {
                  marginTop: "0px !important",
                  marginBottom: "0px !important",
                  backgroundColor: "#EEE",
                  color: "#000",
                },
              },
            }}
            title={info}
            placement="top"
          >
            <Box sx={{ path: { fill: "#000" }, lineHeight: "1px" }}>
              <InfoIcon
                height={15}
                width={15}
                style={{ cursor: "pointer", marginLeft: 4 }}
              />
            </Box>
          </Tooltip>
        ) : null}
      </Box>
      <Box>
        <SettingTextField
          page={"customRestaurantInfo"}
          editable={true}
          value={colorVal}
          setValue={handleInputChange}
          placeholder={""}
          required={true}
          variant={"filled"}
          border={"1px solid #AAA"}
          error={error}
          leftView={
            <Input
              type="color"
              value={colorVal}
              onChange={(e) => handleInputChange(e.target.value)}
              sx={{
                width: "2rem",
                height: "2rem",
                border: 0,
                borderRadius: "0.75rem",
                '& .MuiInputBase-input': {
                  padding: 0,
                  width: '100%',
                  height: '100%'
                }
              }}
            />
          }
        />
      </Box >
    </>
  );
};

export default PortalSettingsColorInput;
